module.exports = __webpack_public_path__ + "img/chevron-up-solid.9b0b6fe4.svg";